var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modelling-controls"},[_c('el-button',{staticClass:"r-button main",attrs:{"loading":_vm.saving,"type":"primary"},on:{"click":_vm.startCalc}},[_vm._v("\n    Запустить расчет\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }